
const Challenges = () => {
  return <div>Challenges</div>;
};

export default Challenges;
